import { TransportData } from "@app/classes/infrastructure/transportdata";
import { TodaysTaskDetailsFetchRequest } from "./todaystasklistdetailsfetchrequest";
import { DataContainerService } from "@app/classes/infrastructure/datacontainer.service";


export interface TodaysTaskDetailRowResponse {
  id: number;
  name: string;
  house_no: string;
  family_serial_number: string;
  mobile: string;
  visit_no: string | number;
}

export class TodaysTaskDetails {
  public static readonly EmbedCollectionName: string = "todays_task_details";

  FetchRequest: TodaysTaskDetailsFetchRequest = null as any;

  public static FromTransportData(td: TransportData): TodaysTaskDetailRowResponse[] {
    const result: TodaysTaskDetailRowResponse[] = [];
    const dcs = DataContainerService.GetInstance();

    if (dcs.CollectionExists(td.MainData, TodaysTaskDetails.EmbedCollectionName)) {
      const coll = dcs.GetCollection(td.MainData, TodaysTaskDetails.EmbedCollectionName)!;
      for (const data of coll.Entries) {
        result.push(data as TodaysTaskDetailRowResponse);
      }
    }
    return result;
  }
}